import { IObstetricaLabResultsGroup } from "@/Common/Api/Labs/Dto/Responses/LabMessageGroupDTO";

interface IHandleObstetricalLabResult {
    getlabs(contactId: string): Promise<IObstetricaLabResultsGroup[]>
}

abstract class BaseObstetricalLabResultHandler implements IHandleObstetricalLabResult {
    public abstract getlabs(contactId: string): Promise<IObstetricaLabResultsGroup[]>;
}

export { BaseObstetricalLabResultHandler, IHandleObstetricalLabResult };
